import { config } from 'lib-shared-backend-config';

import { elevioUrls } from '../utils/apis';

export const snowcatAppId = 'com.elevio.dixa.kcs';
export const snowcatNamespace = 'snowcat';
export const snowcatPlatform = 'web';
export const snowcatUrl =
  config.environment === 'prod'
    ? elevioUrls.production.snowcat
    : elevioUrls.staging.snowcat;
